import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from 'react-i18next';
import ISONumber from "components/formatting/ISONumber";

interface SubqueriesSparklineTooltipProps {
  rowResponse: any;
  rootResponse: any;
  hoveredSparklineIndex: number | null;
}

export default function SubqueriesSparklineTooltip(props: SubqueriesSparklineTooltipProps): JSX.Element {
  const { i18n } = useTranslation();
  const theme = useTheme();
  const { rowResponse, rootResponse, hoveredSparklineIndex }: SubqueriesSparklineTooltipProps = props;

  const rowSparklineData = rowResponse?.responseBody?.histogram?._buckets || [];
  const activeBucket = rowSparklineData[hoveredSparklineIndex || 0];

  return (
    <Box>
      <Typography variant="h4" sx={{ textAlign: "center", fontWeight: "bold", mb:1 }}>
        {i18n.t("social_universe")}
      </Typography>
      <Typography sx={{ fontWeight: "bold", color: theme.palette.primary.main, textAlign: "center", mb:0.5 }}>
        {activeBucket?._label}
      </Typography>
      <Typography sx={{ textAlign: "center" }}>
        <ISONumber typographyVariant="h4"
        number={activeBucket?.social_universe} sx={{ fontWeight: "bold", fontSize: "1.5rem" }}/>
      </Typography>
    </Box>
  );
}
